import type { FC } from 'react';

import { Pagination } from './SliderPagination';

interface SliderPaginationProps {
  className?: string;
  isDark?: boolean;
}

const SliderPagination: FC<SliderPaginationProps> = ({ className, isDark }) => {
  return <Pagination className={className} isDark={isDark} />;
};

export default SliderPagination;
